import { Action, Reducer } from "redux";
import { AnnouncementActionTypes, AnnouncementState, AnnouncementTypes } from "./announcementTypes";

export const INITIAL_STATE: AnnouncementState = {
	domain: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	statusDomain: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	domainCompanyAnnouncers: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	domainWhoCanSee: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const announcementReducer: Reducer<AnnouncementState> = (state: AnnouncementState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as AnnouncementActionTypes;
	switch (actionTypes.type) {
		case AnnouncementTypes.GET_DOMAIN_ANNOUNCEMENTS:
			return {
				...state,
				domain: { ...state.domain, isLoading: true },
			};
		case AnnouncementTypes.SAVE_DOMAIN_ANNOUNCEMENTS:
			return {
				...state,
				domain: {
					...state.domain,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case AnnouncementTypes.GET_STATUS_DOMAIN:
			return {
				...state,
				statusDomain: { ...state.statusDomain, isLoading: true },
			};
		case AnnouncementTypes.SAVE_STATUS_DOMAIN:
			return {
				...state,
				statusDomain: {
					...state.statusDomain,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};

		case AnnouncementTypes.GET_DOMAIN_COMPANY_ANNOUNCERS:
			return {
				...state,
				domainCompanyAnnouncers: {
					...state.domainCompanyAnnouncers,
					isLoading: true,
				},
			};
		case AnnouncementTypes.SAVE_DOMAIN_COMPANY_ANNOUNCERS:
			return {
				...state,
				domainCompanyAnnouncers: {
					...state.domainCompanyAnnouncers,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case AnnouncementTypes.GET_DOMAIN_WHO_CAN_SEE:
			return {
				...state,
				domainWhoCanSee: { ...state.domainWhoCanSee, isLoading: true },
			};
		case AnnouncementTypes.SAVE_DOMAIN_WHO_CAN_SEE:
			return {
				...state,
				domainWhoCanSee: {
					...state.domainWhoCanSee,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		default:
			return state;
	}
};

export default announcementReducer;
